import type React from "react";
import { Link } from "react-router-dom";
import Layout from "../../../components/site/Layout/Layout";
import SignupForm from "./components/SignupForm";
import GoogleAuthButton from "../../../components/common/GoogleAuthButton";
import { Separator } from "../../../components/ui/separator";

const SignupPage: React.FC = () => {
	return (
		<Layout>
			<div className="max-w-md mx-auto mt-8">
				<h1 className="text-3xl font-bold mb-6">新規登録</h1>
				<SignupForm />
				<div className="mt-6 relative">
					<div className="absolute inset-0 flex items-center">
						<Separator className="w-full" />
					</div>
					<div className="relative flex justify-center text-xs uppercase">
						<span className="bg-background px-2 text-muted-foreground">
							または
						</span>
					</div>
				</div>
				<div className="mt-6">
					<GoogleAuthButton mode="signup" />
				</div>
				<div className="mt-4 text-center">
					<p>
						既にアカウントをお持ちの方は
						<Link to="/login" className="text-blue-600 hover:underline">
							こちら
						</Link>
						からログインしてください。
					</p>
				</div>
			</div>
		</Layout>
	);
};

export default SignupPage;
